import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const IconLayoutContainerStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
  m: { sm: '200' },
})`
  ${({ theme }) => css`
    border: solid 1px ${theme.colors.grey['300']};
    width: ${theme.spacings[600]};
    height: ${theme.spacings[600]};
    border-radius: ${theme.spacings[200]};
    background-color: ${theme.colors.white};
  `}
  cursor: pointer;
`;
